import ReactLoading from 'react-loading';
import { ColumnsLocalAccount } from './Column';
import { DefaultTable } from '../Components/DefaultTable';
import FitButtons from '../Components/FitButton';
import { SeeAll } from '../Components/SeeAll';
import { useState } from 'react';
import { FormFieldLocal } from './FormFieldLocal';
import { useRef } from 'react';
import { Data } from './Data';

export const TableLocal = (props) => {
  const [showform, setShowForm] = useState(false);
  const { localAccountData } = Data();
  const ref = useRef(null);

  const handleShowandHideForm = () => {
    setShowForm(!showform);
    ref.current?.element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className='flex flex-col'>
      <div className='flex flex-row justify-between pb-6'>
        <SeeAll name='Local Accounts' seeAll={false} />
        <FitButtons
          details='+ Add bank account'
          color='bigblue'
          icon={false}
          onClick={handleShowandHideForm}
        />
      </div>
      <div className='flex flex-col gap-16'>
        {localAccountData.length === 0 ? (
          <ReactLoading type='cylon' color='#5AC8FA' height={44} width={44} />
        ) : (
          <div className='overflow-x-auto'>
            <DefaultTable
              columns={ColumnsLocalAccount}
              data={localAccountData}
            />
          </div>
        )}
        {showform && (
          <FormFieldLocal toggleAddAccountForm={handleShowandHideForm} />
        )}
      </div>
    </div>
  );
};
